// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Copyright (c) Microsoft Corporation.
Licensed under the MIT License. */

.report-container {
	height: 75vh;
	margin: 8px auto;
	width: 150vh;
}
/* 
body {
	font-family: 'Segoe UI';
	margin: 0;
}

.container {
	display: flex;
	flex-direction: column;
	height: 100vh;
}

.header {
	background: #3476ae 0 0 no-repeat padding-box;
	border: 1px solid #707070;
	color: #ffffff;
	font: 700 22px/27px 'Segoe UI';
	padding: 13px 13px 13px 36px;
	text-align: left;
}

.display-message {
	align-items: center;
	display: flex;
	font: 400 18px/27px 'Segoe UI';
	height: 30px;
	justify-content: center;
	margin-top: 8px;
	text-align: center;
}

.position {
	margin-top: 40vh;
}

.embed-report {
	margin-top: 18px;
	text-align: center;
	margin-right: 0;
	background: #337ab7;
	border: 0;
	border-radius: 5px;
	color: #ffffff;
	font-size: 16px;
	height: 35px;
	margin-right: 15px;
	width: 160px;
}

.controls {
	margin-top: 20px;
	text-align: center;
	flex: 1;
}

.footer {
	align-items: center;
	background: #f7f8fa 0 0 no-repeat padding-box;
	display: flex;
	font: 400 16px/21px 'Segoe UI';
	height: 42px;
	justify-content: center;
	width: 100%;
}

.footer * {
	padding: 0 3px;
}

.footer-icon {
	border-radius: 50%;
	height: 22px;
	vertical-align: middle;
}

.footer a {
	color: #3a3a3a;
	text-decoration: underline;
}

button:hover {
  cursor: pointer;
}

iframe {
	border: none;
} */`, "",{"version":3,"sources":["webpack://./src/@fuse/core/DemoContent/Test.css"],"names":[],"mappings":"AAAA;iCACiC;;AAEjC;CACC,YAAY;CACZ,gBAAgB;CAChB,YAAY;AACb;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAsFG","sourcesContent":["/* Copyright (c) Microsoft Corporation.\nLicensed under the MIT License. */\n\n.report-container {\n\theight: 75vh;\n\tmargin: 8px auto;\n\twidth: 150vh;\n}\n/* \nbody {\n\tfont-family: 'Segoe UI';\n\tmargin: 0;\n}\n\n.container {\n\tdisplay: flex;\n\tflex-direction: column;\n\theight: 100vh;\n}\n\n.header {\n\tbackground: #3476ae 0 0 no-repeat padding-box;\n\tborder: 1px solid #707070;\n\tcolor: #ffffff;\n\tfont: 700 22px/27px 'Segoe UI';\n\tpadding: 13px 13px 13px 36px;\n\ttext-align: left;\n}\n\n.display-message {\n\talign-items: center;\n\tdisplay: flex;\n\tfont: 400 18px/27px 'Segoe UI';\n\theight: 30px;\n\tjustify-content: center;\n\tmargin-top: 8px;\n\ttext-align: center;\n}\n\n.position {\n\tmargin-top: 40vh;\n}\n\n.embed-report {\n\tmargin-top: 18px;\n\ttext-align: center;\n\tmargin-right: 0;\n\tbackground: #337ab7;\n\tborder: 0;\n\tborder-radius: 5px;\n\tcolor: #ffffff;\n\tfont-size: 16px;\n\theight: 35px;\n\tmargin-right: 15px;\n\twidth: 160px;\n}\n\n.controls {\n\tmargin-top: 20px;\n\ttext-align: center;\n\tflex: 1;\n}\n\n.footer {\n\talign-items: center;\n\tbackground: #f7f8fa 0 0 no-repeat padding-box;\n\tdisplay: flex;\n\tfont: 400 16px/21px 'Segoe UI';\n\theight: 42px;\n\tjustify-content: center;\n\twidth: 100%;\n}\n\n.footer * {\n\tpadding: 0 3px;\n}\n\n.footer-icon {\n\tborder-radius: 50%;\n\theight: 22px;\n\tvertical-align: middle;\n}\n\n.footer a {\n\tcolor: #3a3a3a;\n\ttext-decoration: underline;\n}\n\nbutton:hover {\n  cursor: pointer;\n}\n\niframe {\n\tborder: none;\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
